import { render, staticRenderFns } from "./TypeFileJPEGIcon.vue?vue&type=template&id=b77c0a14&"
import script from "./TypeFileJPEGIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFileJPEGIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports